/**
 * Builds `src`/`srcSet` for the photography, whose widths are produced by
 * `scripts/prepare-assets.mjs`. Keeping the width lists here means the markup
 * and the image pipeline cannot drift apart silently — an unknown name throws
 * in development rather than 404ing in the browser.
 */

const WIDTHS = {
  'hero-bg': [640, 1024, 1536, 1920],
  'vision-bg': [640, 1024, 1760],
  'together-bg': [640, 1024, 1760],
  'story-1': [480, 900],
  'story-2': [480, 900],
  'story-3': [480, 900],
  'story-4': [480, 900],
  'story-5': [480, 900],
  'story-6': [480, 900],
};

export default function photo(name) {
  const widths = WIDTHS[name];
  if (!widths) throw new Error(`No generated widths for image "${name}"`);

  return {
    src: `/assets/${name}-${widths[widths.length - 1]}.webp`,
    srcSet: widths.map((w) => `/assets/${name}-${w}.webp ${w}w`).join(', '),
  };
}
